"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _OzContainer = _interopRequireDefault(require("./../OzContainer/OzContainer.js"));

var _OzLogo = _interopRequireDefault(require("./../OzLogo/OzLogo.js"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __jsx = _react.default.createElement;

var Topbar = _styledComponents.default.div.withConfig({
  displayName: "OzTopbar__Topbar",
  componentId: "sc-1wmft9j-0"
})(["\n  position: relative;\n  height: 70px;\n  width: 100%;\n  background-color: #fff;\n  box-shadow: 0 0.125rem 0.25rem rgba(0,0,0,.075);\n  border-bottom: 1px solid #dee2e6;\n\n  &, & * {\n    box-sizing: border-box;\n  }\n"]);

var Content = _styledComponents.default.div.withConfig({
  displayName: "OzTopbar__Content",
  componentId: "sc-1wmft9j-1"
})(["\n  height: 70px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"]);

var Logo = _styledComponents.default.div.withConfig({
  displayName: "OzTopbar__Logo",
  componentId: "sc-1wmft9j-2"
})(["\n  height: 18px;\n  flex-grow: 0;\n  flex-shrink: 1;\n  z-index: 5;\n  line-height: 0px;\n"]);

var Menu = _styledComponents.default.div.withConfig({
  displayName: "OzTopbar__Menu",
  componentId: "sc-1wmft9j-3"
})(["\n\n  @media (max-width: 991px){\n    position: fixed;\n    top: 0px;\n    left: ", ";\n    width: 100vw;\n    height: 100vh;\n    background-color: #ffffff;\n    padding-top: 70px;\n    transition: all 0.25s ease-in-out;\n  }\n\n\n\n"], function (props) {
  return props.isOpen ? "0px" : "-100vw";
});

var Items = _styledComponents.default.div.withConfig({
  displayName: "OzTopbar__Items",
  componentId: "sc-1wmft9j-4"
})(["\n  white-space: nowrap;\n  display: flex;\n  flex-direction: row;\n  list-style: none;\n\n\n  @media (max-width: 991px){\n    flex-direction: column;\n    margin-top: 130px;\n    text-align: center;\n  }\n"]);

var Item = _styledComponents.default.div.withConfig({
  displayName: "OzTopbar__Item",
  componentId: "sc-1wmft9j-5"
})(["\n  padding: 0 12px;\n  vertical-align: middle;\n  @media (max-width: 991px){\n    padding: 12px 0;\n  }\n"]);

var Toggle = _styledComponents.default.div.withConfig({
  displayName: "OzTopbar__Toggle",
  componentId: "sc-1wmft9j-6"
})(["\n  cursor: pointer;\n  z-index: 5;\n  @media (min-width: 992px){\n    display: none;\n  }\n"]);

var OzTopbar = function OzTopbar(_ref) {
  var _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      _ref$logoLink = _ref.logoLink,
      logoLink = _ref$logoLink === void 0 ? null : _ref$logoLink;

  var _useState = (0, _react.useState)(false),
      isOpen = _useState[0],
      setOpen = _useState[1];

  return __jsx(Topbar, null, __jsx(_OzContainer.default, null, __jsx(Content, null, __jsx(Logo, null, logoLink ? __jsx(_react.default.Fragment, null) : __jsx(_OzLogo.default, {
    height: "100%"
  })), __jsx(Menu, {
    isOpen: isOpen
  }, __jsx(Items, null, items.map(function (item, j) {
    return __jsx(Item, {
      key: j
    }, item);
  }))), __jsx(Toggle, {
    onClick: function onClick() {
      return setOpen(!isOpen);
    }
  }, "TODO"))));
};

var _default = OzTopbar;
exports.default = _default;